<template>
    <div class="margin-header">
        <TopBar :title="$vuetify.lang.t('$vuetify.InquiryBureau.pageName')" />
        <div class="box-round display-height">
            <div class="box-content px-0">
                <div class="col-12 pl-7 py-0 font-weight-bold mb-2 d-flex">
                    <div @click="clickBack()" class="liff-line-font-lexendDeca liff-line-font-size-14">{{$vuetify.lang.t('$vuetify.InquiryBureau.pageName')}}</div>
                    <div class="px-1">/</div>
                    <div class="font-roboto liff-line-font-size-14">{{ pageName }}</div>
                </div>
                <div class="px-7 pt-1">
                  <v-select
                    :placeholder="$vuetify.lang.t('$vuetify.InquiryBureau.search.placeholder')"
                    class="line-search-type custom-ddl"
                    :items="options"
                    v-model="approveType"
                    outlined
                    @change="searchByType()"
                  ></v-select>
                </div>
                <div class="d-flex flex-nowrap header-item line-liff-header-table mt-5">
                    <v-col cols="7" class="px-0 py-2 pl-7">
                        {{$vuetify.lang.t('$vuetify.InquiryBureau.header.full')}}
                    </v-col>
                    <v-col cols="5" class="px-0 py-2 text-center">
                        {{$vuetify.lang.t('$vuetify.InquiryBureau.header.sub')}}
                    </v-col>
                </div>
                <div class="font-weight-bold font-roboto">
                  <div class="list-item pb-3" v-for="(v,i) of list" :key="i">
                      <div class="d-flex pt-2">
                          <v-col cols="7 pb-1 pl-7">
                              <i class="fas fa-address-card mr-2 mb-1"></i>
                              <span>{{v.empId}}</span>
                          </v-col>
                          <v-col cols="5 pb-1 text-center">{{v.date}}</v-col>
                      </div>
                      <div class="pl-7 pt-1 pr-5">
                          <div class="mb-2 text-truncate d-flex aligns-center">
                              <v-icon small class="mr-3">fa fa-user</v-icon>
                              <span class="text-truncate">{{v.name}}</span>
                          </div>
                          <div class="mb-2 text-truncate d-flex aligns-center">
                              <v-icon small class="mr-4">fas fa-file-alt</v-icon>
                              <span>{{v.type}}</span>
                          </div>
                          <div class="mb-1 text-truncate d-flex aligns-center">
                                <i class="fas fa-paper-plane mr-3 mt-1"></i>
                                <span>{{v.submittedDate}}</span>
                          </div>
                      </div>
                      <div class="text-center d-flex px-7">
                          <v-col cols="6" class="px-0 pr-2">
                              <v-btn block elevation="2" class="text-capitalize btn-reject" @click="clickBtn('REJ', v.id)">
                                  {{$vuetify.lang.t('$vuetify.InquiryBureau.button.reject')}}
                              </v-btn>
                          </v-col>
                          <v-col cols="6" class="px-0 pl-2">
                              <v-btn block elevation="2" class="text-capitalize btn-approve" @click="clickBtn('APV', v.id)">
                                  {{$vuetify.lang.t('$vuetify.InquiryBureau.button.approve')}}
                              </v-btn>
                          </v-col>
                      </div>
                  </div>
                </div>
            </div>
        </div>
        <ModalSuccess ref="modal-success" @clickOk="searchByType()" />
        <ModalFail ref="modal-fail" />
    </div>
</template>
<script>
import TopBar from '@/components/Liff/Components/header/TopBar.vue'
import ModalFail from '@/components/Liff/Modals/ModalFail.vue'
import ModalSuccess from '@/components/Liff/Modals/ModalSuccess.vue'
export default {
    name: 'InquiryBureau',
    components: {
        TopBar,
        ModalFail,
        ModalSuccess
    },
    data: function () {
        return {
            lineUserId: null,
            lineLiffId: process.env.VUE_APP_LINE_LIFF_LEAVE_INQUIRY,
            idPage: null,
            approveType: null,
            bureau: 'all',
            page: 1,
            title: null,
            options: [],
            list: [],
            pageName: null
        }
    },
    created: function () {
        this.idPage = this.$route.query.id
        this.title = 'Approval Inquiry'
    },
    mounted: function () {
        this.initialData()
    },
    methods: {
        initialData: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)
                this.lineUserId = lineUserId
            } catch {
                // do something with error
            }
            try {
                const res = await this.axios.get('inquiry/type/options')
                this.options = res.data.data
                this.searchByType()
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        },
        clickBack: function () {
            this.$router.push('/liff/inquiry/overview')
        },
        clickBtn: async function (type, id) {
            this.$store.dispatch('setLoading', true)
            try {
                const url = `inquiry/${id}/review`
                const params = {
                    lineId: this.lineUserId,
                    status: type
                }
                const res = await this.axios.post(url, params)
                if (res && res.data && res.data.status === 'ok') {
                    this.openModalSuccess(res.data.msg)
                } else {
                    this.openModalFail(res.data.msg)
                }
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        },
        searchByType: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const url = this.approveType ? `inquiries/line/${this.idPage}?type=${this.approveType}` : `inquiries/line/${this.idPage}`
                const res = await this.axios.post(url, { lineId: this.lineUserId })
                if (res && res.data && res.data.status === 'ok') {
                    this.pageName = res.data.data.shortName
                    this.list = res.data.data.data.map(o => {
                        const date = this.$dateUtil.formatDate(o.date)
                        const submittedDate = this.$dateUtil.formatDate(o.submitted_date)
                        return {
                            ...o,
                            date: date,
                            submittedDate: submittedDate
                        }
                    })
                }
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        },
        openModalSuccess: function () {
            const title = this.$vuetify.lang.t('$vuetify.InquiryBureau.modalSuccess.title')
            const btnOk = this.$vuetify.lang.t('$vuetify.InquiryBureau.modalSuccess.btnOk')
            const body = this.$vuetify.lang.t('$vuetify.InquiryBureau.modalSuccess.body')
            const params = {
                title: title,
                btnOk: btnOk,
                body: body
            }
            this.$refs['modal-success'].show(params)
        },
        openModalFail: function (text) {
            const title = this.$vuetify.lang.t('$vuetify.InquiryBureau.modalFail.title')
            const btnOk = this.$vuetify.lang.t('$vuetify.InquiryBureau.modalFail.btnOk')
            const params = {
                title: title,
                btnOk: btnOk,
                body: text
            }
            this.$refs['modal-fail'].show(params)
        }
    }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/color.scss';
  .btn-approve {
    background-color: $base-blue !important;
    color: #fff;
  }
  .btn-reject {
    background: $base-red !important;
    color: #fff;
  }

  .header-item {
      margin-top: -5px;
      color: $base-grey2;
      background: #d9e4ed;
      font-size: 14px;
  }
  .list-item {
    &:not(:last-child){
        color: $base-grey3;
        border-bottom: 1px solid #e0e0e0;
    }
    font-size: 14px;
    i{
      color: $base-grey;
    }
  }
  .bottom-paging {
    padding: 10px;
    background: #fff;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    font-size: 14px !important;
  }

  ::v-deep .v-select__slot {
      font-family: Roboto !important;
  }

  ::v-deep .v-list-item__content {
    .v-list-item__title {
        font-family: Roboto !important;
    }
  }
</style>
